import { LaunchDto } from '@marina/api-client';

/** Same normalization as the launch board Kanban (legacy API values → column buckets). */
const STATUS_MAP: Record<string, string> = {
  PENDING: 'REQUESTED',
  SCHEDULED: 'LAUNCHED',
  COMPLETED: 'WITH_CLIENT',
  RETURNED: 'RETURNED',
  CANCELLED: 'CANCELLED',
};

export function normalizeLaunchBoardStatus(status: string | null | undefined): string {
  if (!status) return '';
  const u = status.toUpperCase();
  return STATUS_MAP[u] || u;
}

/** Normalizes requestType the same way as the API dashboard wash-rack check. */
function requestTypeIndicatesWashRack(requestType: string | null | undefined): boolean {
  if (!requestType?.trim()) return false;
  const key = requestType.trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
  return key === 'wash_rack' || key === 'washrack';
}

/** Wash Rack column routing — must match `LaunchBoardComponent.isInWashRack` and dashboard launch KPIs. */
export function isLaunchInWashRackColumn(launch: LaunchDto): boolean {
  const status = (launch.status || '').toUpperCase();
  if (status === 'CANCELLED' || status === 'RETURNED') {
    return false;
  }
  const notes = launch.notes?.toLowerCase() ?? '';
  const hasMarker = notes.includes('[wash rack]') || notes.includes('wash rack');
  return hasMarker || requestTypeIndicatesWashRack(launch.requestType);
}

/**
 * Same membership as the first Kanban column ("Requests"): not on Wash Rack, normalized status REQUESTED
 * (includes legacy PENDING).
 */
export function isLaunchInRequestsColumn(launch: LaunchDto): boolean {
  if (isLaunchInWashRackColumn(launch)) return false;
  return normalizeLaunchBoardStatus(launch.status) === 'REQUESTED';
}

export function countLaunchesInRequestsColumn(launches: LaunchDto[]): number {
  return launches.filter(isLaunchInRequestsColumn).length;
}
